export const API_ROUTE = {
    USER_GROUP: '/group', 
    GET_PERMISSIONS: '/permission'  
}